module.exports = __webpack_public_path__ + "img/banner2.d3cf698.jpg";